import { render, staticRenderFns } from "./PreviewRevision.vue?vue&type=template&id=964c1ef4&"
import script from "./PreviewRevision.vue?vue&type=script&lang=js&"
export * from "./PreviewRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports